import { Id, Maybe } from '@vimeo/core/types/generic';
import { Logger } from '@vimeo/logging';

import { environmentConfig } from '../../configs/EnvironmentConfig';
import { liveApplicationConfig } from '../../configs/LiveApplicationConfig';

const log: Logger = new Logger(
  '🗝EM',
  liveApplicationConfig.TRACKING.IS_EMBED_MESSAGING_LOG_ENABLED,
);

/**
 * Post embed iframe message for external origin awareness.
 *
 * @param type - message type to post
 * @param data - data of the message to post
 * @param origin - flag of origin to post message for, supports direct origin or `true` for config check of available one
 * @returns whether message post is called
 */
export function postPageMessage<D, T extends Id = string>(
  type: T,
  data: D,
  origin: string | boolean = true,
): boolean {
  if (environmentConfig.IS_IFRAME && window.parent) {
    try {
      const parentOrigin: string = window.document.referrer;
      let targetOrigin: string = '*';

      if (origin === true) {
        const possibleOrigin: Maybe<string> = environmentConfig.IFRAME_ALLOWED_ORIGINS.find((it) =>
          parentOrigin.startsWith(it),
        );

        if (possibleOrigin) {
          targetOrigin = possibleOrigin;
        } else {
          log.info('Skip posting message, origin is not allowed:', parentOrigin);

          return false;
        }
      } else if (typeof origin === 'string') {
        targetOrigin = origin as string;
      }

      // Post actual message.
      log.info('Posting iframe page message:', type, data, targetOrigin);

      window.parent.postMessage(
        {
          type,
          data,
        },
        targetOrigin,
      );

      return true;
    } catch (error) {
      log.error('Failed to post iframe message:', error);
    }
  } else {
    log.info('Skip iframe post page message:', type, data, origin);
  }

  return false;
}
